var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer client-log-in"},[_c('h4',[_vm._v("© "+_vm._s(_vm.year)+" REPUBLIKA SMAKOSZY. Wszelkie prawa zastrzeżone.")])])}
var staticRenderFns = []

export { render, staticRenderFns }